import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/react";

interface BatchEditModalProps {
  isOpen: boolean;
  filesToEditCount: number;
  canvasSize?: { width: number; height: number };
  onCancel: () => void;
  onStartEditing: () => void;
}

const BatchEditModal: React.FC<BatchEditModalProps> = ({
  isOpen,
  filesToEditCount,
  canvasSize,
  onCancel,
  onStartEditing,
}) => {
  if (!canvasSize) return null;

  return (
    <Modal isOpen={isOpen} onOpenChange={onCancel} size="md">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          Images Need Adjustment
        </ModalHeader>
        <ModalBody>
          <p>
            {filesToEditCount} image{filesToEditCount > 1 ? "s" : ""}{" "}
            {filesToEditCount > 1 ? "don't" : "doesn't"} match the canvas size (
            {canvasSize.width} × {canvasSize.height}px) and can be adjusted.
          </p>
          <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-md mt-3">
            <p className="text-sm text-blue-800 dark:text-blue-200">
              <strong>Canvas Size:</strong> All images will be fitted to{" "}
              {canvasSize.width} × {canvasSize.height}px. You can resize, move,
              and rotate images within the canvas area.
            </p>
          </div>
          <p className="text-sm text-gray-600 mt-2">
            You can edit images individually or start with the first image that
            needs adjustment.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="default" variant="light" onPress={onCancel}>
            Cancel
          </Button>
          <Button color="primary" onPress={onStartEditing}>
            Start Editing
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default BatchEditModal;
